
export default {
  props: ["error"],
};
